module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AuKr"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 18: Not Yours to Carry"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pAT5G"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch19",
      "id": "AB_cha19"
    }
  }, [_vm._v("JANUARY 18"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2a"
  }, [_vm._v("Not Yours to Carry")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pAz8M"
    }
  }, [_c('em', [_vm._v("Cast all your anxiety on him because he cares for you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pAdb7"
    }
  }, [_vm._v("—1 Peter 5:7 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "ADUL"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("O")])]), _vm._v("ur human nature makes us urgently want to control our lives and prompts us to worry about things beyond our control. Some of us worry more than others, but the tendency is widespread enough that God speaks to it: “Cast all your anxiety on [Me].” How do you picture the act of casting?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pA3lb"
    }
  }, [_vm._v("The apostle Peter was not talking about the graceful, gentle motion of a fly fisherman casting his line. Peter was talking about a more forceful act. Consider this story of a young woman camping in the desert. The day of dirt-biking with her friends had been fun but exhausting. Kate was preparing for the most relaxing time of the day: s’mores and talking by the campfire. The kindling had ignited the teepee of wood pieces. It was time to add a log to the fire. Keeping her eye on the young flames, Kate reached to the pile of wood, picked up a piece, glanced at it to confirm its size—then flung it as far away as she could. A furry, eight-legged little body startled her, and Kate knew instantly she wanted the tarantula nowhere near her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAQH9"
    }
  }, [_c('em', [_vm._v("That")]), _vm._v(" is the kind of casting Peter was talking about in today’s verse. Rather than trying to take control, we are to throw—with force and intentionality—the burden of anxiety to Him who cares for us. Thanks be to God!")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pA75I"
    }
  }, [_c('em', [_vm._v("I am grateful for Your willingness, almighty God, to take away all the worry that weighs me down.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b52aa062","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter19.vue
// module id = 123
// module chunks = 0